import { LibraryIcons } from './Library'
import { IconsName } from './types'

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconsName
}

export function Icon({ name, ...props }: IconProps): JSX.Element {
  const IconComponent = LibraryIcons[name]

  if (!IconComponent) return <></>

  return <IconComponent aria-hidden='true' data-testid={`${name}-icon-test`} {...props} />
}
